import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
import 'react-table/react-table.css';
import '../resource/css/selectTable.css';
import '../resource/css/documentosPago.css';
import selectTableHOC from "react-table/lib/hoc/selectTable";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ModalGenerico from './comunes/ModalGenerico';

const SelectedTable = selectTableHOC(ReactTable);

class DocumentosPago extends Component {
constructor() {
    super();
}  
state = {    
    selection: [],
    showError: true,
    expanded : {},
    data:[],
    casoModal: "",
    mostrarModal: false,
    m_modal: ""
};  
 fontSize = 11;

 columns = [
     {id:'_selector', show:false},
     {
        Header: 'Producto',
        //pivot: true,
        //accessor: 'riesgo',
        /*accessor: props => {
            return this.props.riesgo;
            },
        id: 'riesgo',*/
        Cell: props => <div style={{ textAlign: "center" }}>{this.props.riesgo}</div>,        
        minWidth: 160,
        style: {
            fontSize: this.fontSize,
        },
    },
    {pivot: true},
    {
    Header: '#Poliza',
    id:'poliza',
    accessor: props => {
    return (props.codProducto+"-"+props.numPoliza);
    },
    //Pivot: <div>ejemplo</div>,
    PivotValue: (props,a,b,c) => {
                this.state.expanded[props.row._viewIndex]=true;
        return (<div style={{ fontWeight: "bold", marginTop:  (4 + (props.row._subRows.length-1)*15)+"px", position: "absolute", marginLeft:"30px"}}>{props.row.poliza}</div>);
    //return props.row.poliza;
    },
    Expander: (props) => {
        return <div></div>;
    },
    minWidth: 161,
    style: {
        fontSize: this.fontSize,
    }
},
{
    Header: 'Certificado',
    Cell: props => <div style={{ textAlign: "center" }}>{(props.original.certificado )}</div>,
    minWidth: 120,
    style: {
        fontSize: this.fontSize,
    }
},
{
    Header: 'Documento',
    Cell: props => <div style={{ textAlign: "center" }}>{(props.original.tipoDocumento+"/"+props.original.numDocumento )}</div>,
    minWidth: 156,
    style: {
        fontSize: this.fontSize,
    }
}, {
    Header: 'Monto',
    Cell: props => <div style={{ textAlign: "center" }}>{((props.original.moneda==='USD'?"$.":"S/.") + " " +props.original.monto )}</div>,
    minWidth: 120,
    style: {
        fontSize: this.fontSize,
    }
}, {
    Header: 'Vencimiento',
    //accessor: 'fecVenc',
    Cell: props => <div style={{ textAlign: "center" }}>{props.original.fecVenc}</div>,
    minWidth: 139,
    style: {
        fontSize: this.fontSize
    }
}

];

componentDidMount(){
    
}
componentWillReceiveProps(nextProps){
    if (nextProps.documentoSelected ){
        let selection = nextProps.documentoSelected.map(item => {return "select-" + item.documentoCobro})
        
        this.state.selection = selection;
     }else{
        this.state.selection = [];
     }
     this.setState({data: nextProps.mensaje});
}

 render(){
    ReactTableDefaults.column= {...ReactTableDefaults.column, headerClassName: 'tableRemesaHeader', className:'tableRemesaCell'}; 
    return (<Modal
                open={this.props.mostrar || false}
                closeOnEsc={false}
                closeOnOverlayClick={false}
                onClose={this.props.cerrarModal}
                center
                // classNames={{modalGeneralPoliticas:'modalGeneralPoliticas' }}
                classNames={{modal: 'customModal' }}
            >
            <br/>
            <SelectedTable
                isSelected= {(key) => {
                    return this.state.selection.includes("select-"+key); 
                }                 
                }
                toggleSelection = {(key, shift, row) => {
                    let selection = [...this.state.selection];
                    const keyIndex = selection.indexOf(key);

                    let isMoneyEqual = true
                    let equalTypeDoc = true

                    if (this.state.selection.length > 0){
                        const firstSelectedDoc = this.state.selection[0].split("-")[1];
                        const aux = this.state.data.find(item => item.numDocumento === firstSelectedDoc);

                        isMoneyEqual = aux.moneda === row.moneda
                        equalTypeDoc = aux.tipoDocumento === row.tipoDocumento
                    }

                    if (isMoneyEqual && (this.props.producto !== 'VIDA' || equalTypeDoc)){
                        const { numPoliza, certificado, tipoDocumento } = row;

                        const relevantDocs = this.state.data.filter(item => item.numPoliza === numPoliza && item.certificado === certificado && (this.props.producto !== 'VIDA' || item.tipoDocumento === tipoDocumento))
                        const temp = relevantDocs.map(item => "select-"+item.numDocumento)
                        
                        const aux = this.state.data.filter(item => (keyIndex === -1 ? item.index <= row.index : item.index < row.index) && item.numPoliza === row.numPoliza && item.certificado === row.certificado && (this.props.producto !== 'VIDA' || item.tipoDocumento === tipoDocumento)).map(item => "select-"+item.numDocumento)

                        selection = selection.filter(item => !temp.includes(item)).concat(aux)
                        this.setState({selection})
                    }else{
                        this.setState({
                            mostrarModal: true,
                            m_modal: isMoneyEqual ? "Nose puede seleccionar distintos tipos de documentos." : "No se puede seleccionar documentos con distintos tipos de moneda.",
                            casoModal: "mensaje"
                        })
                    }
                }}
                selectType = "checkbox" 
                data={this.state.data}
                columns={this.columns}
                //showPagination={false} 
                defaultPageSize={this.props.polizas && Object.keys(this.props.polizas).length>10?10:Object.keys(this.props.polizas).length}
                //defaultPageSize={15}
                minRows= {0}
                pivotBy={['poliza']}
                expanded={this.state.expanded}
                previousText={"Anterior"}
                nextText={"Siguiente"}
                loadingText={"Cargando..."}
                noDataText={"No hay datos para mostrar"}
                pageText={"Página"}
                ofText={"de"}
                rowsText={"filas"}
                pageSizeOptions={[5, 10]}
                className="-docum"
            /> 
            <br/>
            <Row>
                <Col className="s12 m6 l6" style={{float: "right"}}>
                    <a onClick={(e)=>{
                        this.props.onSelect(this.state.selection.map(item => item.split("-")[1]).map(item => {
													const temp = this.state.data.filter(obj=>obj._id == item)
													return temp[0]
												}));
                        this.props.cerrarModal();
                    }}
                    style={{float: "right"}}              
                    disabled={!this.state.selection.length} 
                    className="btn-rimac waves-effect waves-light btn">Aceptar</a> 
                </Col>
            </Row>
            <ModalGenerico
                caso={this.state.casoModal}
                mostrar={this.state.mostrarModal}
                mensaje={this.state.m_modal}
                cerrarModal={() => this.setState({ mostrarModal: false })}
            />
                
    </Modal>);
 }
}
export default DocumentosPago;


